'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSignalWifi4BarLock = function MdSignalWifi4BarLock(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.9 24.1v4.4l-5.9 7.4-19.3-24.3 0.5-0.3q0.4-0.4 0.9-0.7t1.4-0.9 1.8-1 2.3-1.1 2.6-1 3-0.8 3.2-0.6 3.6-0.2 3.6 0.2 3.2 0.6 3 0.8 2.6 1 2.3 1.1 1.8 1 1.4 0.9 0.9 0.7l0.5 0.3-3.4 4.4q-0.5-0.1-1.8-0.1-3.5 0-5.9 2.3t-2.3 5.9z m10.7 2.5v-2.5q0-1-0.7-1.7t-1.8-0.8-1.7 0.8-0.8 1.7v2.5h5z m1.8 0q0.6 0 1.1 0.6t0.5 1.2v6.6q0 0.6-0.5 1.1t-1.1 0.5h-8.4q-0.6 0-1.1-0.5t-0.5-1.1v-6.6q0-0.7 0.5-1.2t1.1-0.6v-2.5q0-1.8 1.2-2.9t2.9-1.2 3 1.2 1.3 2.9v2.5z' })
        )
    );
};

exports.default = MdSignalWifi4BarLock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/signal-wifi-4-bar-lock.js
// module id = 1974
// module chunks = 168707334958949